import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SignInComponent } from './sign-in/sign-in.component';
import {
  BrowserAnimationsModule,
  NoopAnimationsModule,
} from '@angular/platform-browser/animations';
import { AuthService } from './auth/auth.service';

import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { UseragreementComponent } from './useragreement/useragreement.component';
import { MaterialAppModule } from './ngmaterial.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HttpClientModule } from '@angular/common/http';
import { RegisterComponent } from './register/register.component';
import { AuthGuard } from './auth/auth.guard';
import { LogedinComponent } from './logedin/logedin.component';
import { MrfdComponent } from './mrfd/mrfd.component';
import { DialogOverviewExampleDialogComponent } from './dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { LoaderComponent } from './loader/loader.component';
import { GooglesnakeyComponent } from './googlesnakey/googlesnakey.component';
import { SankeyreportComponent } from './sankeyreport/sankeyreport.component';
import { BarchartComponent } from './barchart/barchart.component';
import { EditUserComponent } from './edit-user/edit-user.component';
import { CommonModule } from '@angular/common';
import { SnakeychartComponent } from './snakeychart/snakeychart.component';
import { ActivatecostComponent } from './activatecost/activatecost.component';
import { AddclientComponent } from './addclient/addclient.component';
import { AddprojectComponent } from './addproject/addproject.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';

const routes: Routes = [
  { path: '', component: SignInComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'mrfd', component: MrfdComponent },
  { path: 'logedin', component: LogedinComponent, canActivate: [AuthGuard] },
  { path: 'chart', component:  SnakeychartComponent },
  { path: 'cost', component: ActivatecostComponent },
  { path: 'edit', component: EditUserComponent },
  { path: 'addclient', component:  AddclientComponent },
  { path: 'addproject', component: AddprojectComponent },
  { path: 'forgotpassword', component: ForgotPasswordComponent },

];

@NgModule({
  declarations: [
    AppComponent,
    SignInComponent,
    UseragreementComponent,
    HeaderComponent,
    FooterComponent,
    RegisterComponent,
    LogedinComponent,
    MrfdComponent,
    LoaderComponent,
    SafeHtmlPipe,
    DialogOverviewExampleDialogComponent,
    SnakeychartComponent,
    GooglesnakeyComponent,
    SankeyreportComponent,
    BarchartComponent,
    ActivatecostComponent,
    EditUserComponent,
    ForgotPasswordComponent,
    AddprojectComponent,
    AddclientComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    MaterialAppModule,
    ReactiveFormsModule,
    FormsModule,
    AppRoutingModule,
    NoopAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot(routes),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [AuthService, AuthGuard],
  bootstrap: [AppComponent],
  entryComponents: [DialogOverviewExampleDialogComponent]
})
export class AppModule {}
